import styled from 'styled-components'

import { MenuContentStyles } from '../Menu/Menu'
import Popover from '../Popover/Popover'

const StyledMenuContent = styled(Popover.Content).attrs({
  align: 'start',
  side: 'bottom',
  role: 'listbox',
  sideOffset: 1,
  onOpenAutoFocus: (e) => e.preventDefault(),
  // Prevent focus from leaving the trigger input when clicking menu items.
  // pointerdown fires before mousedown and can cause blur in some browsers
  // before the mousedown handler gets a chance to preventDefault.
  onPointerDown: (e) => e.preventDefault(),
  onMouseDown: (e) => e.preventDefault(),
  // Prevent Radix's DismissableLayer from closing the Popover when it's
  // nested inside a Dialog (e.g. govwell-ui Modal). Without these, the
  // Dialog's dismiss layer can steal focus or fire an "interact outside"
  // event that unmounts the menu before the click handler registers.
  onInteractOutside: (e) => e.preventDefault(),
  onFocusOutside: (e) => e.preventDefault(),
})<{ $layout?: 'column' | 'grid'; $gridItemWidth?: string }>`
  ${MenuContentStyles};
  min-width: var(--radix-popper-anchor-width);
  max-height: var(--radix-popover-content-available-height);
  gap: 1px;

  ${({ $layout = 'column', $gridItemWidth = '190px' }) =>
    $layout === 'column'
      ? `
    display: flex;
    flex-direction: column;
    max-width: var(--radix-popper-anchor-width);
  `
      : `
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${$gridItemWidth}, 1fr));
    align-items: stretch;
    justify-content: stretch;
    gap: 8px;
    width: 800px;
  `};
`
export default StyledMenuContent
